import { render, staticRenderFns } from "./RepresentativeProductForm.vue?vue&type=template&id=0bbb53a3&scoped=true"
import script from "./RepresentativeProductForm.vue?vue&type=script&lang=js"
export * from "./RepresentativeProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb53a3",
  null
  
)

export default component.exports